<template>
  <v-card
    class="pa-0 ma-0 justify-center preview-container"
    flat
  >
    <v-card-title class="px-4 pb-2" :class="{'separator mb-1': fromSummary}">
      <v-layout row wrap>
        <v-flex xs12>
          <edit-fields
            @update="updateBusinessDetails"
          />
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-spacer />
    <v-card-actions class="py-0 pb-2 card-actions">
      <v-flex xs12 :class="{'ml-3':!$vuetify.breakpoint.xsOnly}">
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'shrink mr-2': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              @click="closeAdDetailsDialog()"
              :disabled="isBtnDisabled"
            >
              <span class="text-capitalize"> {{ $t('message.done') }}</span>
            </v-btn>
          </v-flex>
          <v-flex :class="{ 'shrink ml-2': !$vuetify.breakpoint.xsOnly, 'xs12 mb-2': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              outline
              v-if="!$vuetify.breakpoint.xsOnly"
              @click="closeDialog()"
            >
              {{ $t('message.bizgainOnboarding.discard') }}
            </v-btn>
            <span class="text-xs-center" @click="closeDialog()" v-else>
              <a
                class="text-xs-center my-1"
              > {{ $t('message.bizgainOnboarding.discard') }}</a>
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  VCard,
  VCardTitle,
  VCardActions,
  VLayout,
  VFlex,
  VSpacer
} from 'vuetify/lib';
import EditFields from 'Features/bizgainOnboarding/pages/googleAdsEdit/components/EditFields.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    VCard,
    VCardTitle,
    VCardActions,
    VLayout,
    VFlex,
    VSpacer,
    EditFields
  },
  props: {
    fromSummary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isBtnDisabled: false,
      editedBusinessDetails: null
    }
  },
  created(){
    this.editedBusinessDetails = this.businessDetails;
  },
  computed: {
    ...mapGetters(['businessDetails'])
  },
  methods: {
    closeAdDetailsDialog(){
      this.$emit('update', this.editedBusinessDetails);
      this.closeDialog();
    },
    closeDialog(){
      this.$emit('closeDialog', true);
    },
    updateBusinessDetails(details){
      this.editedBusinessDetails = details;
    }
  }
}
</script>

<style lang="scss" scoped>
.separator{
  border-bottom: 1px solid #aaaaaa;
}
</style>